import { render, staticRenderFns } from "./resume-cta.vue?vue&type=template&id=493ce8ba&scoped=true&"
import script from "./resume-cta.vue?vue&type=script&lang=js&"
export * from "./resume-cta.vue?vue&type=script&lang=js&"
import style0 from "./resume-cta.vue?vue&type=style&index=0&id=493ce8ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ce8ba",
  null
  
)

export default component.exports